<nav id="main-nav" class="fixed w-16 bg-black h-screen sm:left-0 top-0 py-6  z-50 flex flex-col justify-between align-middle text-center text-white " [ngClass]="{'left-0 ': mobileMenuOpen, '-left-full': !mobileMenuOpen }">
  <!-- <span class="nav-back" (click)="goBack()" *ngIf="!backDisabled"><fa-icon [icon]="faChevronLeft"></fa-icon></span> -->
  <div class="nav-inner">
    <img class="mb-4 w-4/5 mx-auto" src="assets/images/logo_white.svg" alt="RS Saddles">
      <div
      class="nav-link my-3 text-2xl hover:text-gray-300 cursor-pointer"
      *ngFor="let page of pages"
      [ngClass]="{'active' : pageIsCurrent(page)}"
      (click)="navigateToPage(page)">
      <fa-icon class="shadow-lg" [icon]="page.icon"></fa-icon></div>
  </div>

  <!--<div id="current-page-title">{{ currentPageTitle }}</div>-->

  <div id="user-details ">
     
      
      <span class="hover:text-gray-300 cursor-pointer" (click)="signOut()">
        <fa-icon [icon]="faSignOut"></fa-icon>
        </span>
  </div>

  

</nav>

<div class="sm:hidden z-50 bg-accent fixed top-[90vh] left-4 text-white text-center flex-col flex align-middle items-center justify-center w-12 h-12 rounded-full" id="menu-toggle" (click)="mobileMenuToggle()">
  <i *ngIf="mobileMenuOpen" class="icon ion-md-close"></i>
  <i *ngIf="!mobileMenuOpen" class="icon ion-md-menu"></i>
</div>


